import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { help, logo, tab10icon, tab1icon, tab2icon, tab3icon, tab4icon, tab5icon, tab6icon, tab7icon, tab8icon, tab9icon } from '../../assets/imagesPath';
import PATHS from '../../routes/Paths';
import { db } from "../firebaseConfig/FirebaseConfig";
import { collection, query, where, onSnapshot, doc, getDoc } from 'firebase/firestore';
import { useSelector } from 'react-redux';
import useUpdateCount from '../customHooks/useUpdateCount';
import useUserSnapshot from '../customHooks/useUserSnapshot';

const Sidebar = () => {

    const [hireInfDropdown, setHireInfDropdown] = useState(false);
    const [emailDropdown, setEmailDropdown] = useState(false);
    const [showCount, setShowCount] = useState(true);
    const [unreadInfo, setUnreadInfo] = useState({ count: 0, senders: [] });
    const location = useLocation();
    const pathName = location.pathname;
    const auth = useSelector((data) => data?.auth);
    const currentUserId = auth?.userDetail?.UserId?.toString();
    const { updateCount } = useUpdateCount();
    const { emailCount } = useUserSnapshot(currentUserId);

    const toggleInfDropdown = () => {
        setHireInfDropdown(!hireInfDropdown);
    };

    const toggleDropdown = () => {
        setEmailDropdown(!emailDropdown);
        setShowCount(!showCount);
    };

    useEffect(() => {
        if (pathName != "/hire-influencers" && pathName != "/hired-influencers" && pathName != "/brand-messages" && pathName != "/emails") {
            setHireInfDropdown(false);
            setEmailDropdown(false);
        }
    }, [pathName]);

    const fetchUserName = async (userId) => {
        const userRef = doc(db, 'chatUsers', userId);
        const userSnapshot = await getDoc(userRef);
        return userSnapshot.exists() ? userSnapshot.data().name : 'Unknown';
    };

    useEffect(() => {
        if (!currentUserId) return;

        const inboxRef = collection(db, 'chats');
        const q = query(inboxRef, where('participants', 'array-contains', currentUserId));

        const unsubscribe = onSnapshot(q, async (querySnapshot) => {
            let unreadCount = 0;
            const sendersSet = new Set();

            for (const doc of querySnapshot.docs) {
                const data = doc.data();
                const unreadMessages = data?.messages?.filter(
                    (message) =>
                        !message?.seen &&
                        message?.receiverId === currentUserId &&
                        message?.senderId !== currentUserId
                );

                if (unreadMessages.length > 0) {
                    unreadCount += unreadMessages?.length;
                    const senderId = unreadMessages[0]?.senderId;

                    const senderName = await fetchUserName(senderId);
                    sendersSet.add(senderName);
                }
            }

            setUnreadInfo({
                count: unreadCount,
                senders: Array.from(sendersSet)
            });
        });

        return unsubscribe;
    }, [currentUserId]);

    return (
        <>
            <div className="p-4 fixedSidebar">
                <div className="d-flex flex-column align-items-center align-items-sm-start">
                    <Link to={PATHS.dashboard} className="brandLogo w-100">
                        <img alt="" className="siteLogo" />
                    </Link>

                    <ul className="nav nav-pills mt-5 w-100 sideNav">
                        <li className="nav-item w-100">
                            <NavLink className="nav-tab" to={PATHS.dashboard}>
                                <img src={tab1icon} alt="" className={`sidebarIcons ${pathName == "/dashboard" ? "iconsFilter" : ""}`} />
                                Dashboard
                            </NavLink>
                        </li>
                        <li className="nav-item w-100">
                            <NavLink className="nav-tab" to={PATHS.findInfluencers}>
                                <img src={tab2icon} alt="" className={`sidebarIcons ${pathName == "/find-influencers" ? "iconsFilter" : ""}`} />
                                Find Influencers
                            </NavLink>
                        </li>
                        <li className="nav-item w-100">
                            <NavLink className="nav-tab" to={PATHS.myNetwork}>
                                <img src={tab3icon} alt="" className={`sidebarIcons ${pathName == "/my-network" ? "iconsFilter" : ""}`} />
                                My Network
                            </NavLink>
                        </li>
                        <li className="nav-item w-100">
                            <NavLink className="nav-tab" to={PATHS.challanges}>
                                <img src={tab4icon} alt="" className={`sidebarIcons ${pathName == "/challenges" ? "iconsFilter" : ""}`} />
                                Challenges
                            </NavLink>
                        </li>
                        <li className="nav-item w-100">
                            <NavLink className="nav-tab" to={PATHS.leaderboard}>
                                <img src={tab10icon} alt="" className={`sidebarIcons ${pathName == "/leaderboard" ? "iconsFilter" : ""}`} />
                                Leaderboard
                            </NavLink>
                        </li>
                        <li className="nav-item w-100">
                            <div className={`nav-tab ${(pathName == "/hire-influencers" || pathName == "/hired-influencers") ? "active activeClr mb-2" : ""}`} onClick={() => { toggleInfDropdown(); setEmailDropdown(false) }} style={{ cursor: 'pointer' }}>
                                <img src={tab5icon} alt="" className={`sidebarIcons ${(pathName == "/hire-influencers" || pathName == "/hired-influencers") ? "iconsFilter" : ""}`} />
                                Direct Hire
                            </div>
                        </li>
                        {hireInfDropdown &&
                            <>
                                <li className="nav-item dropItem w-100">
                                    <NavLink className="nav-tab" to={PATHS.hireInfluencers}>
                                        Search Talent
                                    </NavLink>
                                </li>
                                <li className="nav-item dropItem w-100">
                                    <NavLink className="nav-tab" to={PATHS.hiredInfluencers}>
                                        Your Contract
                                    </NavLink>
                                </li>
                            </>
                        }
                        <li className="nav-item w-100 position-relative">
                            <div className={`nav-tab ${(pathName == "/brand-messages" || pathName == "/emails") ? "active activeClr mb-2" : ""}`} onClick={() => { toggleDropdown(); setHireInfDropdown(false) }} style={{ cursor: 'pointer' }}>
                                <img src={tab6icon} alt="" className={`sidebarIcons ${(pathName == "/brand-messages" || pathName == "/emails") ? "iconsFilter" : ""}`} />
                                Messages & Email
                            </div>
                            {(showCount && unreadInfo?.count > 0) ?
                                <span className="badgeSidebar" style={{ top: "1.5rem" }}>{unreadInfo?.count}</span>
                                : null}
                        </li>
                        {emailDropdown &&
                            <>
                                <li className="nav-item dropItem w-100 position-relative d-flex align-items-center">
                                    <NavLink className="nav-tab" to={PATHS.brandMessages}>
                                        Messages
                                    </NavLink>
                                    {unreadInfo?.count > 0 ?
                                        <span className="badgeSidebar">{unreadInfo?.count}</span>
                                        : null}
                                </li>
                                <li className="nav-item dropItem w-100 position-relative" onClick={() => updateCount(currentUserId, "emailCount")}>
                                    <NavLink className="nav-tab" to={PATHS.emails}>
                                        Emails
                                    </NavLink>
                                    {emailCount > 0 ?
                                        <span className="badgeSidebar" style={{ top: "1.5rem" }}>{emailCount}</span>
                                        : null}
                                </li>
                            </>
                        }
                        <li className="nav-item w-100">
                            <NavLink className="nav-tab" to={PATHS.reports}>
                                <img src={tab7icon} alt="" className={`sidebarIcons ${pathName == "/reports" ? "iconsFilter" : ""}`} />
                                Reports
                            </NavLink>
                        </li>
                        <li className="nav-item w-100">
                            <NavLink className="nav-tab" to={PATHS.brandTransactions}>
                                <img src={tab8icon} alt="" className={`sidebarIcons ${pathName == "/brand-transactions" ? "iconsFilter" : ""}`} />
                                Transactions
                            </NavLink>
                        </li>
                        <li className="nav-item w-100">
                            <NavLink className="nav-tab" to={PATHS.settings}>
                                <img src={tab9icon} alt="" className={`sidebarIcons ${pathName == "/settings" ? "iconsFilter" : ""}`} />
                                Settings
                            </NavLink>
                        </li>
                        <li className="nav-item w-100">
                            <NavLink className="nav-tab" to={PATHS.brandSupport}>
                                <img src={help} alt="" className={`sidebarIcons ${pathName == "/brand-support" ? "iconsFilter" : ""}`} />
                                Help & Support
                            </NavLink>
                        </li>
                    </ul>
                </div>

                {/* <div className='d-flex align-items-center gap-3' style={{ position: "absolute", marginLeft: "5%", bottom: "10%" }}>
                    <img src={help} alt="" height={15} width={15} />
                    <Link to={PATHS.brandSupport} style={{ textDecoration: "none", color: "#667861" }}>
                        <h3 className='mb-0' style={{ fontSize: "1.4rem", fontWeight: "400", fontFamily: "Inter" }}>Help & Support</h3>
                    </Link>
                </div> */}
            </div>
        </>
    );
};

export default Sidebar;